__turbopack_context__.v({
  "brand": "SiteFooter-module-scss-module__OgkfNW__brand",
  "footer": "SiteFooter-module-scss-module__OgkfNW__footer",
  "links": "SiteFooter-module-scss-module__OgkfNW__links",
  "rights": "SiteFooter-module-scss-module__OgkfNW__rights",
});
